import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e78affca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authorization" }
const _hoisted_2 = { class: "authorization__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "authorization__title" }, [
  /*#__PURE__*/_createTextVNode(" Восстановление "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" пароля ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "authorization__check-mail"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Проверьте вашу почту — мы отправили ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ссылку для смены пароля. ")
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Восстановить ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" На главную ")

import { defineComponent, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import type { FormInstance, FormRules } from 'element-plus'
import { passwordApi } from '@/shared/api'
import { showErrorMessage } from '@/shared/utils'
import { COMMON_RULES } from '@/shared/constants'
import WHeaderAuth from '@/widgets/WHeaderAuth/WHeaderAuth.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

let getWidth = screen.width

const passwordRecoveryForm = ref<FormInstance>()
const isMessageSent = ref(false)

const passwordRecoveryFormData = reactive({
  email: '',
})

const passwordRecoveryValidationRules = reactive<FormRules>({
  email: [COMMON_RULES.emailRequired, COMMON_RULES.emailIncorrect],
})

const handleSubmitForm = (form: FormInstance | undefined): void => {
  if (!form) return

  form.validate(async (valid): Promise<boolean> => {
    if (valid) {
      const [error] = await passwordApi.sendPasswordEmail(
        passwordRecoveryFormData.email
      )

      if (error) {
        showErrorMessage(error)

        return false
      }

      isMessageSent.value = true

      return true
    } else {
      return false
    }
  })
}

const handleReturnToAuth = (): void => {
  router.push({ name: 'AuthPage' })
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WHeaderAuth, { class: "layout__header" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (isMessageSent.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _hoisted_8))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref_key: "passwordRecoveryForm",
        ref: passwordRecoveryForm,
        model: _unref(passwordRecoveryFormData),
        rules: _unref(passwordRecoveryValidationRules),
        class: "authorization__form"
      }, {
        default: _withCtx(() => [
          (!isMessageSent.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                class: "password-recovery__form-item",
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(passwordRecoveryFormData).email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(passwordRecoveryFormData).email) = $event)),
                    class: "el-input--authorization",
                    placeholder: "Электронная почта",
                    type: "text"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { class: "authorization__form-button" }, {
            default: _withCtx(() => [
              (!isMessageSent.value)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "el-button--recovery",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSubmitForm(passwordRecoveryForm.value)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "el-button--recovery",
                    onClick: handleReturnToAuth
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})